'use strict';

exports.__esModule = true;
exports.default = undefined;

var _LogMonitor = require('./LogMonitor');

var _LogMonitor2 = _interopRequireDefault(_LogMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LogMonitor2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-log-monitor/lib/index.js
 ** module id = 794
 ** module chunks = 0
 **/